import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_GET_AVAILABLE_OPTION_LIST_FOR_OPTION_PMS = graphql(/* GraphQL */ `
	query OptionPmsGetAvailableOptionListForOptionPms($hotelID: ID!, $date: String!) {
		optionPmsGetAvailableOptionList(hotelID: $hotelID, date: $date) {
			id
			hotelID
			date
			options {
				optionID
				name
				availableAmount
				subOptions {
					subOptionID
					name
					availableAmount
				}
			}
		}
	}
`);
